<template>
  <transition name="el-zoom-in-top">
    <div
      v-show="$store.getters.isShowProfile"
      class="c-white-background dialog-profile"
    >
      <!-- desktop >768px md -->
      <div
        style="max-width:900px"
        class="full-width container colum pt-20 cursor-pointer"
      >
        <div>
          <div class="info-user flex justify-content-between">
            <div class="flex algin-center">
              <div>
                <el-avatar
                  style="background-color: #ffff;"
                  :size="50"
                  :src="getToken().avatar || getImageBySource()"
                >
                  <img :src="getImageBySource()"
                /></el-avatar>
              </div>
              <div class="ml-10">
                <p class="m-0 c-body1 c-bold-text">{{ getToken().fullname }}</p>
                <p style="color:rgba(104, 104, 104, 1)" class="m-0 c-body2">
                  vID {{ getToken().id_display || getToken().vga }}
                </p>
              </div>
            </div>
            <div @click="handleCloseProfile">
              <img :src="bg.icon_closed" alt="" />
            </div>
          </div>
          <div class="info-wallet mt-10 flex">
            <div
              @click="showDialogWallet"
              style="border-radius:50px; padding:8px;min-width:136px"
              class="flex justify-content-between algin-center mr-10 bg-btn-main"
            >
              <div class=" flex algin-center mr-10">
                <img :src="icons.CoinIcon" alt="" />
                <span class="ml-10 c-white c-caption c-bold-text"
                  >{{ formatNumber($store.getters.point) }} đ</span
                >
              </div>
              <img :src="icons.btn_naptien" alt="" />
            </div>
            <div
              style="border-radius:50px; padding:8px;width:136px; opacity:0"
              class="flex justify-content-between algin-center bg-btn-main"
            >
              <div class=" flex algin-center">
                <img :src="icons.CoinIcon" alt="" />
                <span class="ml-10 c-white c-caption c-bold-text">20 M</span>
              </div>
              <img :src="icons.btn_naptien" alt="" />
            </div>
          </div>
          <div
            class="mt-20"
            style="border-radius:5px;background:rgba(238, 240, 242, 1);padding:8px 15px"
          >
            <span class="c-rather-text c-caption pb-10"
              >{{ $t("wap.text58") }}
            </span>
            <p
              style="font-style:italic;"
              @click="handleShowPolicy"
              class="m-0 fw-500 c-tiny c-text-main"
            >
              {{ $t("wap.text59") }}
            </p>
            <div
              style="border-bottom: 1px dashed rgba(184, 184, 184, 1)"
              class="mt-10"
            ></div>
            <div class="flex algin-center justify-content-between mt-10">
              <span class="c-black c-caption fw-500">{{
                $t("wap.text60")
              }}</span>
              <span
                style="text-transform: uppercase;"
                class="c-caption c-bold-text"
                >{{ getToken().type_member }}</span
              >
            </div>
          </div>
          <div class="mt-20">
            <Menu />
          </div>
        </div>
      </div>
      <div class="dialog-container"></div>
    </div>
  </transition>
</template>

<script>
import CoinIcon from "@/assets/img/iconV2/coin.svg";
import CloseIcon from "@/assets/img/iconV2/close.svg";
import { decodeToken, getBackGround } from "@/utils/wapAuth";
import btn_naptien from "@/assets/img/iconV2/btn_naptien.svg";
import Menu from "@/views/pages/wapV2/profile/components/menu.vue";
import { formatNumber } from "@/plugins/init";
import { getToken } from "@/utils/wapAuth";
import { SOURCE_BANK } from "../../../../constant/contant";
export default {
  components: { Menu },
  bodyClass: "profile-page",
  props: {},
  watch: {},
  created() {},
  mounted() {},
  beforeDestroy() {},
  data() {
    return {
      bg: getBackGround(),
      icons: {
        CloseIcon,
        btn_naptien,
        CoinIcon
      },
      images: {
        DefaultAvatar:
          "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png"
      }
    };
  },

  watch: {},
  methods: {
    getToken,
    decodeToken,
    formatNumber,
    getImageBySource() {
      if (getToken().bank_id == SOURCE_BANK.BIDV) {
        return require("@/assets/img/v3/icon/avatar_user_bidv.svg");
      } else {
        return this.images.DefaultAvatar;
      }
    },
    handleShowPolicy() {
      window.open(
        "https://hio.wghn.net/terms-of-service/loyalty-membership-policy",
        "_blank"
      );
      return;
      setTimeout(() => {
        this.handleCloseProfile();
      }, 200);
      return this.$router.push(
        "/wap/redirect-other-service?title=Chính%20sách%20Hội%20viên%20thân%20thiết&type=policy"
      );
    },
    showDialogWallet() {
      this.$store.dispatch("setShowWallet", true);
    },
    handleCloseProfile() {
      this.$store.dispatch("setShowProfile", false);
    }
  }
};
</script>
<style lang="scss">
.el-popover {
  border-radius: 10px !important;
}
</style>

<style scoped>
.dialog-profile {
  background: #f5f5f5;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  z-index: 2000;
}

.divider-view {
  height: 10px !important;
  width: 100%;
  background-color: #e3e3e3;
  margin: 30px 0;
}

.top-spacing {
  padding-top: 100px;
}

.divider-view {
  height: 1px;
  width: 100%;
  margin-bottom: 10px;
  background-color: #ececec;
}

.px-20 {
  padding-left: 20px;
  padding-right: 20px;
}

@media screen and (min-width: 0px) and (max-width: 769px) {
  .top-spacing {
    padding-top: 60px !important;
  }
}
</style>

<style lang="scss">
$divider-color: #d9d9d9;

.divider-view-top {
  height: 15px;
  width: 100%;
}

.column {
  flex-direction: column;
}
.desktop {
  display: block;
}
.mobile {
  display: none;
}
.uppercase {
  text-transform: uppercase;
}
.full-width {
  width: 100%;
}

@media screen and (min-width: 0px) and (max-width: 480px) {
  .desktop {
    display: none;
  }
  .mobile {
    display: block;
  }
}
@media screen and (min-width: 0px) and (max-width: 769px) {
  .desktop {
    display: none;
  }
  .mobile {
    display: block;
  }
}
@media screen and (min-width: 769px) and (max-width: 980px) {
  .top-spacing {
    padding-top: 60px !important;
  }
}
</style>
